<template>
  <MainAppLayout
    :branding-text="brandingText"
    :resolve-icon="getIconComponent"
    :version="version"
    :menu-links-transform="menuLinksTransform"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import MainAppLayout from "core-fe-lib/components-shadcn/layouts/MainAppLayout.vue";
import { useUrl } from "core-fe-lib/composables/useUrl";
import { getIconComponent } from "@/config/icon-map";
import { getMenuGroups, makeMenuLinksTransform } from "@/modules/groups";

declare const __APP_VERSION__: string;
const version = __APP_VERSION__;

const { getSubdomain } = useUrl();
const brandingText = computed(() => getSubdomain() || "Hub");

const { t } = useI18n();
const menuLinksTransform = makeMenuLinksTransform(getMenuGroups(), t);
</script>
